import { SECTION_HREF_MAP as POST_CLOSING_SECTION_KEY } from 'app/pages/loanApplication/tabs/postClosing/EditDrawer/EditDrawer.config';
import {
  getVisibleSectionHrefs,
  resolvePostClosingSectionConfig,
} from 'app/pages/loanApplication/tabs/postClosing/EditDrawer/EditDrawer.utils';

import { getConditionalObject } from 'utils/data';

import { POST_CLOSING_FORM_PATH } from './LoanEditorCustomFormDrawer.constants';

const toPostClosingFormPath = fieldName => `${POST_CLOSING_FORM_PATH}.${fieldName}`;

const getPostClosingSectionFields = ({ sectionKey, postClosingContext }) => {
  const isSectionVisible =
    postClosingContext?.isViewAllowed !== false &&
    getVisibleSectionHrefs(postClosingContext?.isUnsecured).includes(sectionKey);

  if (!isSectionVisible) {
    return [];
  }

  return resolvePostClosingSectionConfig({ sectionKey, ...postClosingContext }).groups.flatMap(
    group => group.fields,
  );
};

const toDrawerPostClosingField = ({ field, postClosingContext }) => ({
  ...field,
  nameInModel: toPostClosingFormPath(field.nameInModel),
  ...getConditionalObject(postClosingContext?.isEditAllowed === false, () => ({
    inputProps: { ...field.inputProps, disabled: true },
  })),
});

export const getDrawerPostClosingSectionFields = ({ sectionKey, postClosingContext }) =>
  getPostClosingSectionFields({ sectionKey, postClosingContext }).map(field =>
    toDrawerPostClosingField({ field, postClosingContext }),
  );

export const POST_CLOSING_SECTION_KEY_BY_FIELD_NAME = Object.values(
  POST_CLOSING_SECTION_KEY,
).reduce((acc, sectionKey) => {
  getPostClosingSectionFields({ sectionKey, postClosingContext: {} }).forEach(field => {
    acc[field.fieldId] = sectionKey;
  });

  return acc;
}, {});

export const getPostClosingConfigFieldsForContext = postClosingContext =>
  Object.values(POST_CLOSING_SECTION_KEY).reduce((acc, sectionKey) => {
    getDrawerPostClosingSectionFields({ sectionKey, postClosingContext }).forEach(field => {
      acc[field.fieldId] = field;
    });

    return acc;
  }, {});
